/** Local calendar date as YYYY-MM-DD in the user's timezone. */
export function getLocalDateKey(date = new Date()) {
  return date.toLocaleDateString("en-CA");
}
